import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Landing } from '../../pages/Landing';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, signup, login, adminLogin } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Landing onSignup={signup} onLogin={login} onAdminLogin={adminLogin} />;
  }

  return <>{children}</>;
};